import { render, staticRenderFns } from "./detail-new.vue?vue&type=template&id=32a028b9&scoped=true&"
import script from "./detail-new.vue?vue&type=script&lang=js&"
export * from "./detail-new.vue?vue&type=script&lang=js&"
import style0 from "./detail-new.vue?vue&type=style&index=0&id=32a028b9&prod&scoped=true&lang=css&"
import style1 from "./detail-new.vue?vue&type=style&index=1&id=32a028b9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a028b9",
  null
  
)

export default component.exports